import React, { Fragment, ReactNode } from 'react';
import { ReactComponent as Logo } from 'assets/common/Logo-Red.svg';
import './styles.scss';
import { Button } from '@cokitchen/cokitchen-components';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import useRoleContext from 'contexts/role.context';

const SecurityLayout = ({ children }: { children: ReactNode }) => {
  const { setRole, setIsMainAdmin } = useRoleContext();
  const navigate = useNavigate();
  const logout = () => {
    localStorage.clear();
    setRole();
    setIsMainAdmin(false);
    navigate(ROUTE_KEYS.LOGIN);
  };
  return (
    <Fragment>
      <div className='py-4 relative'>
        <Logo className='mx-auto' />
        <div className='absolute right-4 top-4 z-10'>
          <Button variant='link' className='text-sm' color='primary' onClick={logout}>
            Logout
          </Button>
        </div>
      </div>
      <hr className='text-[#DCE2EA]' />
      <main className='main text-sm'>{children}</main>
    </Fragment>
  );
};

export default SecurityLayout;
